import type { LoaderFunctionArgs, MetaFunction } from '@remix-run/node'
import { myAccountAction } from '~/actions/myaccount'
import { Footer, Header, MyAccountIndex } from '~/design-system/components'
import { Container } from '~/design-system/primitives'
import { GlobalToastProvider } from '~/hooks/useGlobalToast'
import { cartLoader } from '~/loaders/cart'

export const meta: MetaFunction = () => {
  return [{ title: 'My Account' }]
}

export const loader = async (context: LoaderFunctionArgs) =>
  cartLoader({ ...context, currentStage: 'myaccount' })

export const action = myAccountAction

export const handle = {}

export default function MyAccount() {
  return (
    <>
      <Header />
      <main className="flex flex-col bg-gray-10">
        <Container className="py-6 gap-5 flex flex-col lg:flex-row">
          <GlobalToastProvider>
            <MyAccountIndex />
          </GlobalToastProvider>
        </Container>
      </main>
      <Footer />
    </>
  )
}
